<template>
  <PrintPage :pageNumber="pageNumber">
    <template v-slot:header>
      <slot>
        <PrintHeaderSSPSlim />
      </slot>
    </template>

    <div class="content-box">
      <div class="content-box-header">
        <h2>1. {{ $t('jobSafety') }}</h2>
      </div>
      <div class="content-box-header">
        <h3>{{ $t('jobSafetyEquipmentUsedState') }}</h3>
      </div>
      <div class="two-column-grid">
        <div>{{ $t('jobSafetyEquipmentUsedState') }}</div>
        <div>{{ $t(project.enpalReport.jobSafetyEquipmentUsedState) }}</div>
      </div>
    </div>

    <AttachmentsPrintGrid
      :attachments="project.scaffoldAttachments"
      fieldName="scaffoldAttachments"
      fieldDescription="scaffoldAttachments"
      :maxImages="4"
    />

    <AttachmentsPrintGrid
      :attachments="project.jobSafetyOptionalAttachments"
      fieldName="optionalNotesAndAttachments"
      :maxImages="2"
    >
      <div class="two-column-grid">
        <div>{{ $t('optional_notes_description') }}</div>
        <div>{{ $t(project.enpalReport.jobSafetyOptionalNotes) }}</div>
      </div>
    </AttachmentsPrintGrid>
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';
import PrintHeaderSSPSlim from '@/components/Print/PrintHeaderSSPSlim';
import AttachmentsPrintGrid from '@/components/Print/AttachmentsPrintGrid';
import { range } from '@/helpers/math.js';

export default {
  name: 'MeasurementPrintPage1',
  components: {
    PrintPage,
    PrintHeaderSSPSlim,
    AttachmentsPrintGrid,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  computed: {},
  methods: { range },
};
</script>
